import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/ui/tabs';
import { SurgeonSegment } from './SurgeonSegment';
import { HealthSystemSegment } from './HealthSystemSegment';

export function SolutionsHero() {
  return (
    <section className="pt-32 md:pt-40 pb-20 md:pb-28 bg-background">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        {/* Header */}
        <div className="text-center mb-10 md:mb-14">
          <p className="text-xs font-semibold tracking-widest uppercase text-primary mb-4">
            Solutions
          </p>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold tracking-tight text-foreground leading-tight mb-5">
            One Platform. Total Alignment.
          </h1>
          <p className="text-lg text-muted-foreground leading-relaxed max-w-2xl mx-auto">
            LINK bridges the gap between clinical excellence and financial
            integrity, tailored for every stakeholder in the surgical workflow.
          </p>
        </div>

        {/* Segment Picker Tabs */}
        <Tabs defaultValue="surgeons" className="flex flex-col">
          <div className="flex justify-center mb-10 md:mb-14">
            <TabsList className="bg-secondary border border-border h-12 p-1 rounded-md">
              <TabsTrigger
                value="surgeons"
                className="px-5 md:px-8 text-sm font-semibold rounded-md data-[state=active]:bg-primary/10 data-[state=active]:text-primary data-[state=active]:shadow-none transition-all"
              >
                For Surgeons
              </TabsTrigger>
              <TabsTrigger
                value="health-systems"
                className="px-5 md:px-8 text-sm font-semibold rounded-md data-[state=active]:bg-primary/10 data-[state=active]:text-primary data-[state=active]:shadow-none transition-all"
              >
                For Health Systems &amp; Compliance
              </TabsTrigger>
            </TabsList>
          </div>

          <TabsContent value="surgeons" className="mt-0">
            <SurgeonSegment />
          </TabsContent>

          <TabsContent value="health-systems" className="mt-0">
            <HealthSystemSegment />
          </TabsContent>
        </Tabs>
      </div>
    </section>
  );
}
